import Config from 'react-native-config'
import { shouldShowDateForSearch } from '../../util/common'
import {
    AESEncrypt,
    customToDateTime,
    fromDateTime,
    generateRandomString,
    getEncryptedAuthCodeAndCodeVerifier,
    getEncryptedOtpAndKey,
    getEncryptedOtpPasswordAndKey,
    getEncryptedPwdAndKey,
    isOsMobile,
    pkceCodeChallenge,
    RSAEncrypt,
} from '../../util/util'
import { exportType } from '../static/data'
import { RootStore } from '../store'

const getLoginRequestBody = (mobNumber: string, pwd: string) => {
  const encPwdNKey = getEncryptedPwdAndKey(pwd)
  return {
    user: {
      mobile: {
        mobileNumber: mobNumber,
        countryCode: '91',
      },
    },
    authenticateList: [
      {
        mode: 9,
        value: encPwdNKey?.password ?? '',
      },
    ],
    scope: 'SESSION',
    purpose: '1',
    secure: {
      encryptionKey: encPwdNKey?.key ?? '',
    },
  }
}
export const getSendOtpWithEmailReq = (emailAddress: string) => {
  return {
    user: { emailAddress, mobile: { mobileNumber: '1234567890', countryCode: '91' } },
    scope: 'REQUEST',
    authenticateList: [{ mode: '43', action: 'generate' }],
    purpose: 2,
  }
}
export const getValidateEmailOtpReq = (emailId: string, otp: string, mob: string) => {
  const encPwdNKey = getEncryptedPwdAndKey(otp)
  return {
    user: {
      emailAddress: emailId,
      mobile: {
        mobileNumber: mob,
      },
    },
    scope: 'SESSION',
    authenticateList: [{ mode: '43', action: 'verify', value: encPwdNKey?.password ?? '' }],
    purpose: 2,
    secure: {
      encryptionKey: encPwdNKey?.key,
    },
  }
}

export const getUserBody = (mUser: any): any => {
  return {
    mid: mUser.mid,
    merchantMobNumber: mUser.merchantMobNumber,
    mercBussName: mUser.mercBussName,
    mercTerminalId: mUser.mercTerminalId,
    mercUuid: mUser.mercUuid,
    userMobNo: mUser.userMobNo,
    userFname: mUser.userFname,
    userLname: mUser.userLname,
    userAccess: {
      dashboardFlag: mUser.dashboardFlag,
      mapMyDevFlag: mUser.mapMyDevFlag,
      holdRelFlag: mUser.holdRelFlag,
      refReceiptsFlag: mUser.refReceiptsFlag,
      accPaymentFlag: mUser.accPaymentFlag,
      userManageflag: mUser.userManageflag,
      storeManageFlag: mUser.storeManageFlag,
      accManageFlag: mUser.accManageFlag,
      reportFlag: mUser.reportFlag,
      mpaReportFlag: mUser.mpaReportFlag,
    },
  }
}

export const getUpdateUserBody = (mUser: any): any => {
  return {
    userId: mUser.userId,
    mid: mUser.mid,
    userFname: mUser.userFname,
    userLname: mUser.userLname,
    userAccess: {
      dashboardFlag: mUser.dashboardFlag,
      mapMyDevFlag: mUser.mapMyDevFlag,
      holdRelFlag: mUser.holdRelFlag,
      refReceiptsFlag: mUser.refReceiptsFlag,
      accPaymentFlag: mUser.accPaymentFlag,
      userManageflag: mUser.userManageflag,
      storeManageFlag: mUser.storeManageFlag,
      accManageFlag: mUser.accManageFlag,
      reportFlag: mUser.reportFlag,
      mpaReportFlag: mUser.mpaReportFlag,
    },
  }
}
const getAppLoginRequestBody = (mobNumber: string) => {
  const secretCode = isOsMobile() ? Config.REACT_APP_SECRET_CODE : window?._env_?.REACT_APP_SECRET_CODE
  const encPwdNKey = getEncryptedPwdAndKey(secretCode ?? '')

  return {
    application: {
      applicationName: 'merchant portal',
      clientId: isOsMobile() ? Config.REACT_APP_CLIENT_ID : window?._env_?.REACT_APP_CLIENT_ID,
      mobile: {
        mobileNumber: mobNumber,
      },
      emailAddress: '',
    },
    authenticateList: [
      {
        mode: 20,
        value: encPwdNKey?.password ?? '',
      },
    ],
    scope: 'SESSION',
    purpose: '2',
    secure: {
      encryptionKey: encPwdNKey?.key ?? '',
    },
  }
}

const getOtpRequestBody = (phoneNumber: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: '91',
      },
    },
    authenticateList: [
      {
        mode: 46,
        value: '',
        action: 'GENERATE',
      },
    ],
    scope: 'SESSION',
    purpose: '5',
  }
}

const appAuthGenerateRequestBody = (codeVerifier: string) => {
  const challenge = pkceCodeChallenge(codeVerifier)
  const encCodeChallenge = getEncryptedPwdAndKey(challenge.toString())

  return {
    application: {
      clientId: isOsMobile() ? Config.REACT_APP_CLIENT_ID : window?._env_?.REACT_APP_CLIENT_ID, //TODO: remove and uncomment this //
    },
    authenticateList: [
      {
        mode: 24,
        action: 'GENERATE',
        value: encCodeChallenge?.password ?? '',
      },
    ],
    purpose: 2,
    scope: 'REQUEST',
    secure: {
      encryptionKey: encCodeChallenge?.key ?? '',
      method: 'SHA-256',
    },
  }
}

const appAuthVerifyRequestBody = (authCode: string, codeVerifier: string) => {
  const encryptedObj = getEncryptedAuthCodeAndCodeVerifier(authCode, codeVerifier)

  return {
    application: {
      clientId: isOsMobile() ? Config.REACT_APP_CLIENT_ID : window?._env_?.REACT_APP_CLIENT_ID, //TODO: remove and uncomment this //
    },
    authenticateList: [
      {
        mode: 24,
        action: 'VERIFY',
        authorizationCode: encryptedObj?.authCodeEnc ?? '',
        value: encryptedObj?.codeVerifierEnc ?? '',
      },
    ],
    purpose: 2,
    scope: 'SESSION',
    secure: {
      encryptionKey: encryptedObj?.key ?? '',
    },
  }
}

const getGenerateOtpReqForApiCred = (phoneNumber: string) => {
  const { key } = getEncryptedOtpAndKey('')
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: '91',
      },
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: '18',
        action: 'generate',
      },
    ],
    purpose: 1,
    secure: {
      encryptionKey: key,
    },
  }

  /*  user: {
      userId: phoneNumber,
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: 17,
        action: 'GENERATE',
      },
    ],
    purpose: 1,
  } */
}

const getOtpAuthRequestBody = (phoneNumber: string, otp: string) => {
  const { OTP, key } = getEncryptedOtpAndKey(otp)
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: '91',
      },
    },
    authenticateList: [
      {
        mode: 18,
        action: 'verify',
        value: OTP,
      },
    ],
    purpose: 1,
    secure: {
      encryptionKey: key,
    },
  }
}

const getCreateMerchantBody = (mid: string, accObj: any) => {
  return {
    financialProfile: {
      bank_name: accObj?.accHolderName,
      account_number: accObj?.accNumber,
      ifsc_code: accObj?.ifsc,
    },
    mid: mid,
  }
}

const getGenerateSettlementFileBody = (
  mid: string,
  startDateTime: string,
  enDate: string,
  fileType: string,
  isSmid: boolean,
  isMobile?: boolean,
  date?: any,
) => {
  const dateArr = date?.split('-')
  const settlmtDate = new Date(dateArr?.[2], dateArr?.[1] - 1, dateArr?.[0])
  const fromDate = `${fromDateTime(settlmtDate)}`
  const toDate = `${customToDateTime(settlmtDate, true)}`
  return fileType !== ''
    ? {
        inputFilter: {
          merchantId: mid,
          startDateTime: isMobile ? fromDate : startDateTime,
          endDateTime: isMobile ? toDate : enDate,
          transactionType: 'SETTLEMENT',
          isSMID: isSmid ? 'Y' : 'N',
        },
        configParams: {
          mediaType: exportType.get(fileType),
        },
      }
    : {
        inputFilter: {
          merchantId: mid,
          startDateTime: isMobile ? fromDate : startDateTime,
          endDateTime: `${isMobile ? toDate : enDate}`,
          isSMID: isSmid ? 'Y' : 'N',
          transactionType: 'SETTLEMENT',
        },
      }
}

const getSignUpOtpRequestBody = (phoneNum: string) => {
  return {
    mobile: {
      number: phoneNum,
      countryCode: '91',
    },
  }
}

const getResetPasswordRequestBody = (mobNumber: string, otpString: string, pwd: string) => {
  const encPwdNKey = getEncryptedOtpPasswordAndKey(otpString, pwd)
  return {
    user: {
      mobile: {
        mobileNumber: mobNumber,
        countryCode: '91',
      },
    },
    validation: {
      type: 1,
      otp: encPwdNKey?.OTP ?? '',
    },
    credentialType: 8,
    credentialValue: encPwdNKey?.Password ?? '',
    encryptionKey: encPwdNKey?.key ?? '',
  }
}

const getOnboardRequestBody = (mobNumber: string, otpString: string, pwd: string) => {
  const encPwdNKey = getEncryptedOtpPasswordAndKey(otpString, pwd)

  return {
    mobile: {
      countryCode: '91',
      number: mobNumber,
    },
    passCode: encPwdNKey?.Password ?? '',
    otp: encPwdNKey?.OTP ?? '',
    encryptionKey: encPwdNKey?.key ?? '',
  }
}

const getChangePwdRequestBody = (mobNumber: string, newEncPwd: string, oldEncPwd: string, encKey: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: mobNumber,
        countryCode: '91',
      },
    },
    credentialType: 8,
    credentialValue: newEncPwd,
    oldCredentialValue: oldEncPwd,
    encryptionKey: encKey,
  }
}

const getTransactionV3RequestBody = (obj: any) => {
  const requestObject: any = {}
  // mandatory fields
  requestObject.inputFilter = {}
  requestObject.configParams = {}
  requestObject.inputFilter.merchantId = obj.merchantId

  requestObject.inputFilter.startDateTime = obj.isRecent ? undefined : obj.startDateTime
  requestObject.inputFilter.endDateTime = obj.isRecent ? undefined : obj.endDateTime
  requestObject.inputFilter.transactionType = obj.transactionType
  requestObject.inputFilter.fetchTokenizedTransactions = obj.fetchTokenizedTransactions
  // configurable fields
  if (obj.responseType) {
    requestObject.inputFilter.responseType = obj.responseType
  }

  if (obj.paymentMethods) {
    if (obj.paymentMethods.includes('ALL')) {
      requestObject.inputFilter.paymentMethods = []
    } else {
      requestObject.inputFilter.paymentMethods = obj.paymentMethods
        .filter((item: any) => item !== 'ALL')
        .map((item: any) => item.toUpperCase())
    }
  }

  if (obj.transactionStatus) {
    if (obj.transactionStatus.includes('ALL')) {
      requestObject.inputFilter.status = []
    } else {
      requestObject.inputFilter.status = obj.transactionStatus
        .filter((item: any) => item !== 'ALL')
        .map((item: any) => item.toUpperCase())
    }
  }

  if (obj.minimumTransactionAmount) {
    requestObject.inputFilter.minimumTransactionAmount = +obj.minimumTransactionAmount
  }
  if (obj.maximumTransactionAmount) {
    requestObject.inputFilter.maximumTransactionAmount = +obj.maximumTransactionAmount
  }
  if (obj.page) {
    requestObject.configParams.page = obj.page
  }
  if (obj.recordCount) {
    requestObject.configParams.recordCount = obj.recordCount
  }
  if (obj.sortType) {
    requestObject.configParams.sortType = obj.sortType
  }
  if (obj.sortColumn) {
    requestObject.configParams.sortColumn = obj.sortColumn
  }
  if (obj.mediaType) {
    requestObject.configParams.mediaType = obj.mediaType
  }
  if (obj.outputDomains) {
    requestObject.outputDomains = obj.outputDomains
  }
  if (obj?.searchKey && obj?.searchString?.length > 0 && !obj.isRecent) {
    //Changes as per v3 transactions api
    const getValue: any = {
      transactionId: [obj.searchString],
      invoice: [obj.searchString],
      bankReferenceNumber: [obj.searchString],
      customerId: [obj.searchString],
      mobileNumber: obj.searchString,
      email: obj.searchString,
      cardNumber: [obj.searchString],
    }
    requestObject.inputFilter[obj.searchKey] = getValue[obj.searchKey] ?? obj.searchString

    requestObject.inputFilter.isGlobalSearch = 'Y'

    // below fields are not required in search call case
    // removing after discussing with Sujit.Chincholkar
    if (!shouldShowDateForSearch(RootStore.settings.metaData.searchFilterItem)) {
      delete requestObject.inputFilter.startDateTime
      delete requestObject.inputFilter.endDateTime
    }
  }
  if (obj.mediaType) {
    requestObject.configParams.mediaType = obj.mediaType
  }
  if (obj.sourceSystem) {
    requestObject.inputFilter.sourceSystem = obj.sourceSystem
  }
  if (obj.email) {
    requestObject.inputFilter.email = obj.email
  }
  if (obj.mobileNumber) {
    requestObject.inputFilter.mobileNumber = obj.mobileNumber
  }
  if (obj.idempotentKey) {
    requestObject.inputFilter.idempotentKey = obj.idempotentKey
  }
  if (obj.referenceNumber) {
    requestObject.inputFilter.referenceNumber = obj.referenceNumber
  }
  if (obj.invoice) {
    requestObject.inputFilter.invoice = obj.invoice
  }
  if (obj.transactionId && obj.searchString === undefined) {
    requestObject.inputFilter.transactionId = obj.transactionId
  }
  if (obj.subMids) {
    requestObject.inputFilter.subMerchantId = obj?.subMids?.[0]
  }
  if (obj.isSmid) {
    requestObject.inputFilter.isSMID = 'Y'
  }
  if (obj.isRecent) {
    requestObject.inputFilter.isRecentTxn = 'Y'
  }
  return requestObject
}

const getMerchantRequestBody = (mid: string) => {
  return {
    inputFilter: {
      mid: mid,
    },
    outputDomains: ['PROFILE', 'FINANCIAL_PROFILE', 'GST', 'CONTACT', 'ADDRESSES', 'TERMINAL'],
    configParams: {
      mediaType: 'application/json',
    },
  }
}

const getMerchantMetaDataRequestBody = (mid: string) => {
  return {
    jfsUserId: mid,
    entityType: 1,
    getProfile: true,
  }
}

const getMerchantMidListRequestBody = (userId: string) => {
  return {
    inputFilter: {
      userID: userId,
    },
    outputDomains: ['PROFILE', 'FINANCIAL_PROFILE', 'GST', 'CONTACT', 'ADDRESSES', 'TERMINAL'],
    configParams: {
      mediaType: 'application/json',
    },
  }
}

const getSessionValidateRequestBody = (data: any) => {
  return {
    accessToken: data?.userAccessToken ?? '',
    refreshToken: data?.userRefreshToken ?? '',
    userIdentifierToken: data?.userIdToken ?? '',
  }
}

const getAppExpireRequestBody = (data: any) => {
  return {
    accessToken: data?.appAccessToken ?? '',
  }
}

const getAppExtendSessionBody = (data: any) => {
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let token = AESEncrypt(randomEncryptionKey, data.appAccessToken)
  let refToken = AESEncrypt(randomEncryptionKey, data.appRefreshToken)

  return {
    application: {
      // clientId: isOsMobile() ? 'b4b8da4c4d2e553a1386ac82e614ff4b' : 'ecab21a088d39fffa70f5a4dd4a403fd', // PKCE
      clientId: isOsMobile() ? Config.REACT_APP_CLIENT_ID : window?._env_?.REACT_APP_CLIENT_ID,
    },
    authenticateList: [
      {
        mode: 14,
        accessToken: token,
        refreshToken: refToken,
      },
    ],
    scope: 'SESSION',
    purpose: 1,
    secure: {
      encryptionKey: encryptedKey ?? '',
    },
  }
}

const getUserExtendSessionBody = (mobNumber: string, data: any) => {
  const accToken = data?.userAccessToken ?? ''
  const refToken = data?.userRefreshToken ?? ''
  let randomEncryptionKey = generateRandomString(32)
  const encryptedKey = RSAEncrypt(randomEncryptionKey)
  let encToken = AESEncrypt(randomEncryptionKey, accToken)
  let encRefToken = AESEncrypt(randomEncryptionKey, refToken)
  return {
    user: {
      mobile: {
        mobileNumber: mobNumber,
        countryCode: '91',
      },
    },
    scope: 'SESSION',
    authenticateList: [
      {
        mode: 14,
        accessToken: encToken ?? '',
        refreshToken: encRefToken ?? '',
      },
    ],
    secure: {
      encryptionKey: encryptedKey,
    },
    purpose: 1,
  }
}
const createUserDeviceRequestBody = (
  appId: string,
  appType: string,
  deviceId: string,
  deviceToken: string,
  operatingSystem: number,
) => {
  return {
    appId: appId,
    appType: appType,
    deviceId: deviceId,
    deviceToken: deviceToken,
    operatingSystem: operatingSystem,
  }
}

const updateUserDeviceRequestBody = (deviceId: string, appId: string, status: number) => {
  return {
    deviceId: deviceId,
    appId: appId,
    status: status,
  }
}

//TODO: update object fields
const subScriptionHistoryRequest = (request: any, configParams: any) => {
  return {
    inputFilter: {
      merchantId: request?.merchantId,
      startDateTime: request?.startDateTime,
      endDateTime: request?.endDateTime,
      transactionStatus: request?.transactionStatus,
      externalUserId: request?.externalUserId,
      Amount: request?.amount, // { minimumAmount: '0', maxAMount: '3000' }, // optional fillter
      createdAt: request?.createdAt,
      updatedAt: request?.updatedAt,
      customerMobileNumber: request?.customerMobileNumber, //  { countryCode: '+91', number: '9834235789' },
      customerName: request?.customerName,
      customerEmail: request?.customerEmail,
      revocable: request?.revocable,
    },
    configParams: {
      page: configParams?.page,
      recordCount: configParams?.recordCount,
      sortType: configParams?.sortType,
      sortColumn: configParams?.sortColumn,
    },
  }
}

const transactionHistoryRequest = (subscriptionId: string) => {
  return {
    subscriptionId: subscriptionId,
  }
}

const getRefundV3Body = (
  mid: string,
  fromDate: any,
  toDate: any,
  self: any,
  curentPage: number,
  fields: any,
  isSmid: boolean,
  isRecent: boolean,
  filter?: any,
) => {
  let requestObject: any = {}
  requestObject.inputFilter = {}
  requestObject = {
    inputFilter: {
      merchantId: mid,
      responseType: 'ALL',
      startDateTime: isRecent ? undefined : fromDate, //Format in yyyy-mm-dd hh:mm:ss
      endDateTime: isRecent ? undefined : toDate, //Format in yyyy-mm-dd hh:mm:ss
      transactionType: 'REFUND',
      paymentMethods: filter?.paymentMode,
      status: filter?.transactionStatus,
      isSMID: isSmid ? 'Y' : 'N',
      subMerchantId: self?.filter?.mid?.[0],
      isRecentTxn: isRecent ? 'Y' : 'N',
    },
    configParams: {
      mediaType: 'JSON',
      sortColumn: 'transactionDateTime',
      page: curentPage,
      recordCount: 10,
    },
    outputDomains: fields,
  }
  const minimumFilterAmount = Number(filter?.min)
  const maximumFilterAmount = Number(filter?.max)
  if (filter?.min !== '') {
    requestObject.inputFilter.minimumTransactionAmount = minimumFilterAmount
  }
  if (filter?.max !== '') {
    requestObject.inputFilter.maximumTransactionAmount = maximumFilterAmount
  }
  return requestObject
}

const generateOtpOnNonIDAM = (phoneNumber: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: '91',
      },
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: '1',
        action: 'generate',
      },
    ],
    purpose: 2,
  }
}

const checkUserMobileOnIDAM = (phoneNumber: string) => {
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: '91',
      },
    },
    scope: 'REQUEST',
    authenticateList: [
      {
        mode: '32',
      },
    ],
    purpose: 8,
  }
}

const setPwdOnIDAMRequestBody = (mobNumber: string, pwd: string, otpString: string) => {
  const { OTP, Password, key } = getEncryptedOtpPasswordAndKey(otpString, pwd)
  return {
    user: {
      mobile: {
        mobileNumber: mobNumber,
        countryCode: '91',
      },
    },
    validation: {
      type: 1,
      otp: OTP,
    },
    credentialType: 9,
    credentialValue: Password,
    encryptionKey: key,
  }
}

export {
    appAuthGenerateRequestBody,
    appAuthVerifyRequestBody,
    checkUserMobileOnIDAM,
    createUserDeviceRequestBody,
    generateOtpOnNonIDAM,
    getAppExpireRequestBody,
    getAppExtendSessionBody,
    getAppLoginRequestBody,
    getChangePwdRequestBody,
    getCreateMerchantBody,
    getGenerateOtpReqForApiCred,
    getGenerateSettlementFileBody,
    getLoginRequestBody,
    getMerchantMetaDataRequestBody,
    getMerchantMidListRequestBody,
    // getTransactionRequestBody,
    getMerchantRequestBody,
    getOnboardRequestBody,
    getOtpAuthRequestBody,
    getOtpRequestBody,
    getRefundV3Body,
    getResetPasswordRequestBody,
    getSessionValidateRequestBody,
    getSignUpOtpRequestBody,
    getTransactionV3RequestBody,
    getUserExtendSessionBody,
    setPwdOnIDAMRequestBody,
    subScriptionHistoryRequest,
    transactionHistoryRequest,
    updateUserDeviceRequestBody
}

